import React from 'react';
import PropTypes from 'prop-types';
import FormHelperCrud from './FormHelperCrud';
import FormHelperModal from './FormHelperModal';

const FormHelperDefault = (props) => {
  // do not pass context, it will interfere with connected redux components
  const { helper, context, ...rest } = props;

  if (typeof helper === 'object') {
    return <FormHelperCrud helper={helper} {...rest} />;
  }

  return <FormHelperModal helper={helper} {...rest} />;
};

FormHelperDefault.propTypes = {
  helper: PropTypes.oneOfType([
    PropTypes.object, // ?
    PropTypes.string,
  ]),
  context: PropTypes.object,
};

export default FormHelperDefault;
